export default "__VITE_ASSET__IXlb4dO5__"